import { type RouteLocationRaw, type RouteRecordRaw } from 'vue-router'

import { useOrganisationStore } from '@/stores/organisations'

const Clients = () => import('@/pages/clients/AllClients.vue')
const AnalyticsTrends = () => import('@/pages/analytics/PartnerOrg/Trends.vue')

function recordsOrgAccessGuard(): boolean | RouteLocationRaw {
  const organisationStore = useOrganisationStore()
  if (organisationStore.currentOrg?.type === 'records') return true

  return { name: 'NotFound' }
}

export const partnerOrgRoutes: RouteRecordRaw[] = [
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    beforeEnter: [recordsOrgAccessGuard],
    meta: {
      breadcrumbs: {
        name: 'Clients',
      },
    },
  },
  // analytics
  {
    path: '/partner-analytics',
    beforeEnter: [recordsOrgAccessGuard],
    meta: {
      breadcrumbs: {
        name: 'Analytics',
      },
    },
    children: [
      {
        path: 'trends',
        name: 'partner-analytics-trends',
        component: AnalyticsTrends,
        meta: {
          breadcrumbs: {
            name: 'Trends Over Time',
          },
        },
      },
    ],
  },
]
